import { useSelector } from "react-redux";
import JobCardHistoryForm from "./JobCardHistoryForm";
import JobCardResults from "./result/JobCardResults";
import NoHistoryView from "./NoHistoryView";
import useGetHistory from "../../../../CustomHooks/useAxios/useGetHistory";
import LoadingDisplay from "../../../../components/UI/LoadingDisplay";

const CylinderJobCardManager = ({ setupData }) => {
  const historyError = useSelector((state) => state.data.error);
  const historyErrMsg = useSelector((state) => state.data.errMessage);
  const data = useSelector((state) => state.data.data);
  const { getHistory, isSucceed, historyLoaded } = useGetHistory();

  return (
    <>
      <JobCardHistoryForm
        setupData={setupData}
        getHistory={getHistory}
        historyError={historyError}
        historyErrMsg={historyErrMsg}
      />
      {historyLoaded ? (
        <LoadingDisplay height="h-[calc(100vh-11em)] lg:h-[calc(100vh-13em)] mt-2" />
      ) : isSucceed && data.length > 0 ? (
        <JobCardResults />
      ) : (
        <NoHistoryView isSucceed={isSucceed} dataLength={data.length} />
      )}
    </>
  );
};

export default CylinderJobCardManager;
